<template>
  <div>
    <Nav></Nav>
    <b-container fluid class="mt-3">
      <b-row>
        <b-col>
          <h1>Areas de Restaurante</h1>
        </b-col>
      </b-row>
      <b-row class="text-left my-2">
        <b-col>
          <b-button variant="success" @click="openCreateModal" size="sm mr-3">Crear Area +</b-button>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group label="Buscar:">
            <b-form-input type="search" v-model="search" @keyup="page = 1" debounce="500"></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-table small :filter="search" striped hover :items="areas" :fields="tableFields" responsive
            :per-page="byPage" :current-page="page">
            <template #table-busy>
              <div class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Loading...</strong>
              </div>
            </template>
            <template #cell(status)="data">
              <b-badge :variant="data.item.status === 'active' ? 'success' : 'danger'">
                {{ data.item.status === 'active' ? 'Activo' : 'Inactivo' }}
              </b-badge>
            </template>
            <template #cell(automatic_payment)="data">
              <b-badge :variant="data.item.automatic_payment ? 'success' : 'secondary'">
                {{ data.item.automatic_payment ? 'Si' : 'No' }}
              </b-badge>
            </template>
            <template #cell(buttons)="data">
              <b-button size="sm" variant="warning" @click="openEditModal(data.item)" class="mr-1">
                Editar
              </b-button>
              <b-button size="sm" variant="info" @click="openLabelsModal(data.item)" class="mr-1">
                Etiquetas
              </b-button>
              <b-button size="sm" variant="primary" @click="openAutoProductsModal(data.item)" class="mr-1">
                Auto Productos
              </b-button>
              <b-button size="sm" variant="danger" @click="confirmDelete(data.item)">
                Eliminar
              </b-button>
            </template>
          </b-table>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-pagination v-model="page" :total-rows="areas.length" :per-page="byPage" aria-controls="my-table">
          </b-pagination>
        </b-col>
      </b-row>
    </b-container>

    <!-- Create/Edit Area Modal -->
    <b-modal id="modal-area" @close="resetForm" :hide-footer="true" size="lg"
      :title="(editItem.id > 0 ? 'Editar' : 'Crear') + ' Area'">
      <b-form @submit.prevent="saveArea">
        <b-row>
          <b-col lg="6" cols="12">
            <b-form-group label="Nombre">
              <b-form-input v-model="editItem.name" placeholder="Nombre del area" required></b-form-input>
            </b-form-group>
          </b-col>
          <b-col lg="6" cols="12">
            <b-form-group label="Copias de Ticket">
              <b-form-input v-model.number="editItem.copy_tickets" type="number" min="0"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col lg="6" cols="12">
            <b-form-group label="Imagen">
              <b-form-input v-model="editItem.image" placeholder="Nombre de imagen"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col lg="6" cols="12">
            <b-form-group label="Estado">
              <b-form-select v-model="editItem.status">
                <b-form-select-option value="active">Activo</b-form-select-option>
                <b-form-select-option value="inactive">Inactivo</b-form-select-option>
              </b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col lg="6" cols="12">
            <b-form-group label="Pago Automatico">
              <b-form-checkbox v-model="editItem.automatic_payment">
                Habilitar pago automatico
              </b-form-checkbox>
            </b-form-group>
          </b-col>
          <b-col lg="6" cols="12" v-if="editItem.automatic_payment">
            <b-form-group label="Metodo de Pago Automatico">
              <b-form-select v-model="editItem.autopayment_method_id" :options="paymentMethods">
                <template #first>
                  <b-form-select-option :value="null">-- Selecciona metodo --</b-form-select-option>
                </template>
              </b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col lg="6" cols="12">
            <b-form-group label="Vale de Entrega">
              <b-form-checkbox v-model="editItem.vale_entrega">
                Habilitar vale de entrega
              </b-form-checkbox>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col class="my-3">
            <b-button type="submit" variant="success" class="mr-3">
              {{ editItem.id > 0 ? 'Actualizar' : 'Crear' }}
            </b-button>
            <b-button @click="$bvModal.hide('modal-area')" variant="danger">Cancelar</b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-modal>

    <!-- Labels Modal -->
    <b-modal id="modal-labels" :hide-footer="true" size="xl" :title="'Etiquetas - ' + selectedArea.name">
      <b-row>
        <b-col cols="12">
          <h5>Etiquetas personalizadas para esta area</h5>
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col cols="12">
          <b-button variant="success" size="sm" @click="showAddLabelForm = true" v-if="!showAddLabelForm">
            + Agregar Etiqueta
          </b-button>
        </b-col>
      </b-row>

      <!-- Add/Edit Label Form -->
      <b-row v-if="showAddLabelForm" class="mt-3">
        <b-col cols="12">
          <b-card bg-variant="light">
            <b-row>
              <b-col lg="4" cols="12">
                <b-form-group label="Key (identificador)">
                  <b-form-input v-model="editLabel.key_name" placeholder="ej: mesa_numero" required></b-form-input>
                </b-form-group>
              </b-col>
              <b-col lg="4" cols="12">
                <b-form-group label="Etiqueta (visible)">
                  <b-form-input v-model="editLabel.label" placeholder="ej: Numero de Mesa" required></b-form-input>
                </b-form-group>
              </b-col>
              <b-col lg="4" cols="12">
                <b-form-group label="Tipo de Dato">
                  <b-form-select v-model="editLabel.data_type">
                    <b-form-select-option value="text">Texto</b-form-select-option>
                    <b-form-select-option value="number">Numero</b-form-select-option>
                  </b-form-select>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row v-if="editLabel.data_type === 'number'">
              <b-col lg="4" cols="12">
                <b-form-group label="Minimo">
                  <b-form-input v-model.number="editLabel.min" type="number"></b-form-input>
                </b-form-group>
              </b-col>
              <b-col lg="4" cols="12">
                <b-form-group label="Maximo">
                  <b-form-input v-model.number="editLabel.max" type="number"></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col lg="4" cols="12">
                <b-form-group label="Valor por Defecto">
                  <b-form-input v-model="editLabel.default"></b-form-input>
                </b-form-group>
              </b-col>
              <b-col lg="4" cols="12">
                <b-form-group label="Visible">
                  <b-form-checkbox v-model="editLabel.visible">
                    Mostrar en interfaz
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12">
                <b-button variant="success" size="sm" @click="saveLabel" class="mr-2">
                  {{ editLabel.id > 0 ? 'Actualizar' : 'Guardar' }}
                </b-button>
                <b-button variant="secondary" size="sm" @click="cancelAddLabel">Cancelar</b-button>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>

      <!-- Labels List -->
      <b-row class="mt-3">
        <b-col cols="12">
          <b-table small striped hover :items="areaLabels" :fields="labelsFields" responsive>
            <template #table-busy>
              <div class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Cargando...</strong>
              </div>
            </template>
            <template #cell(visible)="data">
              <b-badge :variant="data.item.visible ? 'success' : 'secondary'">
                {{ data.item.visible ? 'Si' : 'No' }}
              </b-badge>
            </template>
            <template #cell(actions)="data">
              <b-button size="sm" variant="warning" @click="editLabelItem(data.item)" class="mr-1">
                Editar
              </b-button>
              <b-button size="sm" variant="danger" @click="confirmDeleteLabel(data.item.id)">
                Eliminar
              </b-button>
            </template>
          </b-table>
        </b-col>
      </b-row>

      <b-row class="mt-3">
        <b-col cols="12">
          <b-button variant="secondary" @click="closeLabelsModal">Cerrar</b-button>
        </b-col>
      </b-row>
    </b-modal>

    <!-- Auto Products Modal -->
    <b-modal id="modal-autoProducts" :hide-footer="true" size="xl" :title="'Auto Productos - ' + selectedArea.name">
      <b-row>
        <b-col cols="12">
          <h5>Productos que se agregan automaticamente al crear una orden en esta area</h5>
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col cols="12">
          <b-button variant="success" size="sm" @click="showAddProductForm = true" v-if="!showAddProductForm">
            + Agregar Producto
          </b-button>
        </b-col>
      </b-row>

      <!-- Add Product Form -->
      <b-row v-if="showAddProductForm" class="mt-3">
        <b-col cols="12">
          <b-card bg-variant="light">
            <b-row>
              <b-col lg="6" cols="12">
                <b-form-group label="Producto">
                  <b-form-select v-model="newAutoProduct.product_id" :options="productOptions">
                    <template #first>
                      <b-form-select-option :value="null" disabled>-- Selecciona un producto --</b-form-select-option>
                    </template>
                  </b-form-select>
                </b-form-group>
              </b-col>
              <b-col lg="3" cols="12">
                <b-form-group label="Cantidad">
                  <b-form-input v-model.number="newAutoProduct.quantity" type="number" min="1"></b-form-input>
                </b-form-group>
              </b-col>
              <b-col lg="3" cols="12">
                <b-form-group label="Estado">
                  <b-form-select v-model="newAutoProduct.status">
                    <b-form-select-option :value="true">Activo</b-form-select-option>
                    <b-form-select-option :value="false">Inactivo</b-form-select-option>
                  </b-form-select>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12">
                <b-button variant="success" size="sm" @click="createAutoProduct" class="mr-2">Guardar</b-button>
                <b-button variant="secondary" size="sm" @click="cancelAddProduct">Cancelar</b-button>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>

      <!-- Auto Products List -->
      <b-row class="mt-3">
        <b-col cols="12">
          <b-table small striped hover :items="autoProducts" :fields="autoProductsFields" responsive>
            <template #table-busy>
              <div class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Cargando...</strong>
              </div>
            </template>
            <template #cell(status)="data">
              <b-badge :variant="data.item.status ? 'success' : 'danger'">
                {{ data.item.status ? 'Activo' : 'Inactivo' }}
              </b-badge>
            </template>
            <template #cell(actions)="data">
              <b-button size="sm" variant="danger" @click="deleteAutoProduct(data.item.id)">
                Eliminar
              </b-button>
            </template>
          </b-table>
        </b-col>
      </b-row>

      <b-row class="mt-3">
        <b-col cols="12">
          <b-button variant="secondary" @click="closeAutoProductsModal">Cerrar</b-button>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";
import Nav from "../components/Nav.vue";
import restaurantAreaService from "../services/restaurantAreaService";
import restaurantAreaLabelService from "../services/restaurantAreaLabelService";
import autoProductsService from "../services/autoProductsService";

export default {
  name: "RestaurantAreas",
  components: {
    Nav
  },

  data() {
    return {
      search: "",
      page: 1,
      byPage: 20,
      areas: [],
      tableFields: [
        { key: "id", label: "ID", sortable: true },
        { key: "name", label: "Nombre", sortable: true },
        { key: "copy_tickets", label: "Copias Ticket" },
        { key: "automatic_payment", label: "Pago Auto" },
        { key: "status", label: "Estado" },
        { key: "buttons", label: "Acciones" }
      ],
      // Edit form
      editItem: {
        id: 0,
        name: '',
        copy_tickets: 0,
        image: '',
        automatic_payment: false,
        autopayment_method_id: null,
        vale_entrega: false,
        status: 'active'
      },
      paymentMethods: [],
      // Selected area for labels/auto products
      selectedArea: {},
      // Labels
      areaLabels: [],
      showAddLabelForm: false,
      editLabel: {
        id: 0,
        restaurant_area_id: null,
        key_name: '',
        label: '',
        data_type: 'text',
        min: 0,
        max: 10000,
        default: '',
        visible: true
      },
      labelsFields: [
        { key: "id", label: "ID" },
        { key: "key_name", label: "Key" },
        { key: "label", label: "Etiqueta" },
        { key: "data_type", label: "Tipo" },
        { key: "default", label: "Default" },
        { key: "visible", label: "Visible" },
        { key: "actions", label: "Acciones" }
      ],
      // Auto Products
      autoProducts: [],
      showAddProductForm: false,
      newAutoProduct: {
        restaurant_area_id: null,
        product_id: null,
        quantity: 1,
        status: true
      },
      productOptions: [],
      autoProductsFields: [
        { key: "id", label: "ID" },
        { key: "product_id", label: "ID Producto" },
        { key: "quantity", label: "Cantidad" },
        { key: "status", label: "Estado" },
        { key: "actions", label: "Acciones" }
      ]
    };
  },

  mounted() {
    this.loadAreas();
    this.loadPaymentMethods();
  },

  methods: {
    async loadAreas() {
      try {
        const response = await restaurantAreaService.getAll();
        this.areas = response.data || [];
      } catch (err) {
        console.error('Error loading areas:', err);
        this.makeToast('danger', 'Error', 'No se pudieron cargar las areas');
      }
    },

    async loadPaymentMethods() {
      try {
        const response = await axios.get('/paymentmethods');
        this.paymentMethods = (response.data || []).map(pm => ({
          value: pm.id,
          text: pm.name
        }));
      } catch (err) {
        console.error('Error loading payment methods:', err);
      }
    },

    openCreateModal() {
      this.resetForm();
      this.$bvModal.show('modal-area');
    },

    openEditModal(item) {
      this.editItem = { ...item };
      this.$bvModal.show('modal-area');
    },

    resetForm() {
      this.editItem = {
        id: 0,
        name: '',
        copy_tickets: 0,
        image: '',
        automatic_payment: false,
        autopayment_method_id: null,
        vale_entrega: false,
        status: 'active'
      };
    },

    async saveArea() {
      try {
        if (this.editItem.id > 0) {
          await restaurantAreaService.update(this.editItem.id, this.editItem);
          this.makeToast('success', 'Exito', 'Area actualizada correctamente');
        } else {
          await restaurantAreaService.create(this.editItem);
          this.makeToast('success', 'Exito', 'Area creada correctamente');
        }
        this.$bvModal.hide('modal-area');
        this.loadAreas();
      } catch (err) {
        console.error('Error saving area:', err);
        this.makeToast('danger', 'Error', err.response?.data || 'No se pudo guardar el area');
      }
    },

    async confirmDelete(item) {
      const confirmed = await this.$bvModal.msgBoxConfirm(
        `¿Estas seguro de eliminar el area "${item.name}"?`,
        {
          title: 'Confirmar eliminacion',
          okVariant: 'danger',
          okTitle: 'Eliminar',
          cancelTitle: 'Cancelar',
          centered: true
        }
      );

      if (confirmed) {
        try {
          await restaurantAreaService.delete(item.id);
          this.makeToast('success', 'Exito', 'Area eliminada correctamente');
          this.loadAreas();
        } catch (err) {
          console.error('Error deleting area:', err);
          this.makeToast('danger', 'Error', 'No se pudo eliminar el area');
        }
      }
    },

    // Labels Methods
    async openLabelsModal(area) {
      this.selectedArea = area;
      this.editLabel.restaurant_area_id = area.id;
      await this.loadLabels(area.id);
      this.$bvModal.show('modal-labels');
    },

    async loadLabels(areaId) {
      try {
        const response = await restaurantAreaLabelService.getByAreaId(areaId);
        this.areaLabels = response.data || [];
      } catch (err) {
        console.error('Error loading labels:', err);
        this.makeToast('danger', 'Error', 'No se pudieron cargar las etiquetas');
      }
    },

    editLabelItem(item) {
      this.editLabel = { ...item };
      this.showAddLabelForm = true;
    },

    async saveLabel() {
      if (!this.editLabel.key_name || !this.editLabel.label) {
        this.makeToast('warning', 'Advertencia', 'Por favor completa los campos requeridos');
        return;
      }

      try {
        if (this.editLabel.id > 0) {
          await restaurantAreaLabelService.update(this.editLabel.id, this.editLabel);
          this.makeToast('success', 'Exito', 'Etiqueta actualizada correctamente');
        } else {
          this.editLabel.restaurant_area_id = this.selectedArea.id;
          await restaurantAreaLabelService.create(this.editLabel);
          this.makeToast('success', 'Exito', 'Etiqueta creada correctamente');
        }
        await this.loadLabels(this.selectedArea.id);
        this.cancelAddLabel();
      } catch (err) {
        console.error('Error saving label:', err);
        this.makeToast('danger', 'Error', err.response?.data || 'No se pudo guardar la etiqueta');
      }
    },

    async confirmDeleteLabel(labelId) {
      const confirmed = await this.$bvModal.msgBoxConfirm(
        '¿Estas seguro de eliminar esta etiqueta?',
        {
          title: 'Confirmar eliminacion',
          okVariant: 'danger',
          okTitle: 'Eliminar',
          cancelTitle: 'Cancelar',
          centered: true
        }
      );

      if (confirmed) {
        try {
          await restaurantAreaLabelService.delete(labelId);
          this.makeToast('success', 'Exito', 'Etiqueta eliminada correctamente');
          await this.loadLabels(this.selectedArea.id);
        } catch (err) {
          console.error('Error deleting label:', err);
          this.makeToast('danger', 'Error', 'No se pudo eliminar la etiqueta');
        }
      }
    },

    cancelAddLabel() {
      this.showAddLabelForm = false;
      this.editLabel = {
        id: 0,
        restaurant_area_id: this.selectedArea.id,
        key_name: '',
        label: '',
        data_type: 'text',
        min: 0,
        max: 10000,
        default: '',
        visible: true
      };
    },

    closeLabelsModal() {
      this.$bvModal.hide('modal-labels');
      this.selectedArea = {};
      this.areaLabels = [];
      this.showAddLabelForm = false;
    },

    // Auto Products Methods
    async openAutoProductsModal(area) {
      this.selectedArea = area;
      this.newAutoProduct.restaurant_area_id = area.id;
      await this.loadAutoProducts(area.id);
      await this.loadProducts();
      this.$bvModal.show('modal-autoProducts');
    },

    async loadAutoProducts(areaId) {
      try {
        const response = await autoProductsService.getAutoProductsByAreaId(areaId);
        this.autoProducts = response.data || [];
      } catch (err) {
        console.error('Error loading auto products:', err);
        this.makeToast('danger', 'Error', 'No se pudieron cargar los productos automaticos');
      }
    },

    async loadProducts() {
      try {
        const response = await axios.get('/productswithoutprices');
        this.productOptions = (response.data || [])
          .filter(p => p.status)
          .map(p => ({
            value: p.id,
            text: `${p.ndescription || p.clave || 'Sin nombre'} (ID: ${p.id})`
          }));
      } catch (err) {
        console.error('Error loading products:', err);
        this.makeToast('danger', 'Error', 'No se pudieron cargar los productos');
      }
    },

    async createAutoProduct() {
      if (!this.newAutoProduct.product_id) {
        this.makeToast('warning', 'Advertencia', 'Por favor selecciona un producto');
        return;
      }

      try {
        await autoProductsService.createAutoProduct(this.newAutoProduct);
        this.makeToast('success', 'Exito', 'Producto automatico agregado correctamente');
        await this.loadAutoProducts(this.selectedArea.id);
        this.cancelAddProduct();
      } catch (err) {
        console.error('Error creating auto product:', err);
        this.makeToast('danger', 'Error', err.response?.data || 'No se pudo agregar el producto automatico');
      }
    },

    async deleteAutoProduct(autoProductId) {
      const confirmed = await this.$bvModal.msgBoxConfirm(
        '¿Estas seguro de eliminar este producto automatico?',
        {
          title: 'Confirmar eliminacion',
          okVariant: 'danger',
          okTitle: 'Eliminar',
          cancelTitle: 'Cancelar',
          centered: true
        }
      );

      if (confirmed) {
        try {
          await autoProductsService.deleteAutoProduct(autoProductId);
          this.makeToast('success', 'Exito', 'Producto automatico eliminado correctamente');
          await this.loadAutoProducts(this.selectedArea.id);
        } catch (err) {
          console.error('Error deleting auto product:', err);
          this.makeToast('danger', 'Error', 'No se pudo eliminar el producto automatico');
        }
      }
    },

    cancelAddProduct() {
      this.showAddProductForm = false;
      this.newAutoProduct = {
        restaurant_area_id: this.selectedArea.id,
        product_id: null,
        quantity: 1,
        status: true
      };
    },

    closeAutoProductsModal() {
      this.$bvModal.hide('modal-autoProducts');
      this.selectedArea = {};
      this.autoProducts = [];
      this.showAddProductForm = false;
    },

    makeToast(variant = null, title = "", text = "") {
      this.$bvToast.toast(text, {
        title: title,
        variant: variant,
        autoHideDelay: 5000,
        appendToast: true
      });
    }
  }
};
</script>
